import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  BrandsFiltrationRequestSchema,
  CompaniesSchema,
  CompanySchema,
} from '../shared/schemas.js';

export const company = defaultClient.query({
  url: 'authentication/v1/companies/' as const,
  method: 'GET',
  responseSchema: CompaniesSchema,
  processResponse(data) {
    return data;
  },
});

export const updateCompany = defaultApi.declareEndpoint({
  url: 'authentication/v1/companies/$companyId/',
  method: 'PATCH',
  responseSchema: CompanySchema,
  requestSchema: BrandsFiltrationRequestSchema,
});
